import { ENVIRONMENT_NAME } from '@/configs/environment';

export const isDevelopment = (): boolean => {
  return process.env.NAME === ENVIRONMENT_NAME.DEVELOPMENT;
};
